import { object } from "@/common/object.util";
import ApiAdmin from "@/services/apiAdmin.service";

import {
  FETCH_ALL,
  SAVE,
  CLEAR_ALL,
  FETCH_ALL_GROUPS_KEYCLOAK
} from "@/store/actions/actions.type";

import {
  FETCH_ALL_START,
  SET_ALL,
  FETCH_ALL_END,
  UNSET_ALL,
  FETCH_START,
  SET,
  FETCH_END,
  DELETE_START,
  DELETE_END,
  SAVE_START,
  SAVE_END,
  SET_DEFAULT_USER,
  SET_ALL_GROUPS_KEYCLOAK
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  groups: {
    data: []
  },
  usuarios: {
    current_page: 1,
    per_page: 10,
    data: []
  }
});

const state = {
  groups: object.clone(defaults.groups),
  usuarios: object.clone(defaults.usuarios),
  isFetchingUsuario: false,
  isFetchingUsuarios: false,
  isSavingUsuarios: false,
  usuario: object.clone(defaults.usuario),
  usuarioOriginal: object.clone(defaults.usuario),
};
const getters = {
  usuario(state) {
    return state.usuario;
  },
  usuarios(state) {
    return state.usuarios;
  },
  groups(state) {
    return state.groups;
  },
  isFetchingUsuario(state) {
    return state.isFetchingUsuario;
  },
  isFetchingUsuarios(state) {
    return state.isFetchingUsuarios;
  },
  isSavingUsuarios(state) {
    return state.isSavingUsuarios;
  }
};

const actions = {
  [FETCH_ALL_GROUPS_KEYCLOAK](context, params) {
    return new Promise((resolve, reject) => {
      ApiAdmin.query("leads/group/list", params)
        .then(response => {
          context.commit(SET_ALL_GROUPS_KEYCLOAK, response.data);
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data);
        });
    });
  },
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiAdmin.query("leads/users/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response.data);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [SAVE](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SAVE_START);
      if (!params.isUpdate) {
        ApiAdmin.post("leads/users/create", params)
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject(e);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      } else {
        ApiAdmin.post("leads/users/update", params)
          .then(response => {
            resolve(response.data);
          })
          .catch(e => {
            reject(e);
          })
          .finally(() => {
            context.commit(SAVE_END);
          });
      }
    });
  },
  [CLEAR_ALL](context) {
    return new Promise(resolve => {
      context.commit(UNSET_ALL);
      resolve();
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingUsuarios = true;
  },
  [SET_DEFAULT_USER](state) {
    state.usuario = object.clone(state.defaultUsuario);
  },
  [SET_ALL](state, usuarios) {
    state.usuarios.data = usuarios;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingUsuarios = false;
  },
  [UNSET_ALL](state) {
    state.usuarios = object.clone(defaults.usuarios);
  },
  [SAVE_START](state) {
    state.isSavingUsuarios = true;
  },
  [FETCH_START](state) {
    state.isFetchingUsuario = true;
  },
  [SET](state, usuario) {
    state.usuario = usuario;
    state.usuarioOriginal = object.clone(usuario);
  },
  [FETCH_END](state) {
    state.isFetchingUsuario = false;
  },
  [SAVE_END](state) {
    state.isSavingUsuarios = false;
  },
  [SET_ALL_GROUPS_KEYCLOAK](state, groups) {
    state.groups.data = groups;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
